module.exports = __webpack_public_path__ + "static/img/wyws.dc73578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wyws.jpg
// module id = aEQZ
// module chunks = 1